<script setup>
import {ref} from 'vue';

import AppMenuItem from './AppMenuItem.vue';
import building from "@/utils/building";

const model = ref([
  {
    label: 'Home',
    items: [{label: 'Dashboard', icon: 'pi pi-fw pi-home', to: '/'}]
  },
  {
    label: 'Incoming',
    items: building
  },
]);
</script>

<template>
  <ul class="layout-menu">
    <template v-for="(item, i) in model" :key="item">
      <app-menu-item v-if="!item.separator" :item="item" :index="i"></app-menu-item>
      <li v-if="item.separator" class="menu-separator"></li>
    </template>
    <li>
      <div class="flex flex-column align-items-center mt-8">
        <a href="https://vmtech.co.id/" target="_blank">
          <img src="@/assets/img/vmtech.jpeg" alt="" class="w-full mt-3" style="max-width: 70px"/>
        </a>
        <small class="mt-1">Powered By: VMTECH</small>
      </div>
    </li>
  </ul>
</template>

<style lang="scss" scoped></style>
